// Long-form educational guides (SEO/GEO/AEO). Add each new guide import here.
import divorceDelhi from "./how-to-file-divorce-delhi";
import mutualDivorce from "./mutual-consent-divorce-india";
import legalNotice from "./how-to-send-legal-notice-india";
import propertyRegistration from "./property-registration-delhi";
import verifyTitle from "./how-to-verify-property-title-delhi-ncr";
import reraComplaint from "./rera-complaint-delhi-ncr";

// Ordered newest-first for the Insights listing.
export const guides = [
  divorceDelhi,
  mutualDivorce,
  legalNotice,
  propertyRegistration,
  verifyTitle,
  reraComplaint,
];
